/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.querySelectorAll('.accordion-header').forEach((header) => {
  header.addEventListener('click', () => {
    const accordionItem = header.parentElement; // Obtient l'élément parent de l'accordéon
    accordionItem.classList.toggle('active'); // Ajoute ou supprime la classe active

    const content = accordionItem.querySelector('.accordion-content'); // Sélectionne le contenu de l'accordéon
    if (accordionItem.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px'; // Ajuste la hauteur au contenu
    } else {
      content.style.maxHeight = 0; // Réinitialise la hauteur à 0
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Début du Black Friday : 28 nov 00:00
  var startDate = new Date("Nov 28, 2025 22:30:00").getTime();

  // Fin du Black Friday : 29 nov 00:00 (24h après)
  var endDate = new Date("Nov 29, 2025 00:00:00").getTime();

  function pad(n) {
    return n < 10 ? "0" + n : n;
  }

  var x = setInterval(function () {
    var now = new Date().getTime();

    

    var distance = endDate - now;
    
if (distance < 0) {
      const countdown = document.getElementById("countdown");
      if (countdown) {
        countdown.innerHTML = "terminé !";
      }
      clearInterval(x);
      return;
    }

    var hours = Math.floor(distance / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("countdown").innerHTML =
      pad(hours) + " : " + pad(minutes) + " : " + pad(seconds);
  }, 1000);
});












  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-item-remove]');
  if (!button) return;

  const allItems = document.querySelectorAll('[data-cart-item]');
  allItems.forEach((cartItem) => {
    if (cartItem.classList.contains('cart__item--easify-hidden')) {
      const hiddenItemId = cartItem.getAttribute('data-item');
      if (hiddenItemId) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: hiddenItemId, quantity: 0 }),
        });
      }
    }
  });
});

